import { useMutation } from "@tanstack/react-query";
import { useNotificationStore } from "@src/shared/components/Notification";
import { deleteUserAccount } from "@src/entities/user/api/request/deleteUserAccount";

export const useDeleteUserAccount = () => {
  const { showAlert } = useNotificationStore();

  const query = useMutation({
    mutationFn: deleteUserAccount,
    onError: (error) => {
      showAlert(error.message, "error");
    },
  });
  return query;
};
